import type {
  DeceasedData,
  DocumentData,
  SmartAction,
  ServiceData,
  StreamData,
} from "./types/types";

export const deceasedData: DeceasedData = {
  nickname: "Amena",
  religion: "Christianity",
  denomination: "Methodist",
};

export const documents: DocumentData[] = [
  { name: "Internetagreementform.pdf", size: "300KB" },
  { name: "Internetagreementform.pdf", size: "300KB" },
];

export const smartActions: SmartAction[] = [
  {
    title: "Client Information",
    subtitle: "All fields completed",
    progress: "4/4",
    status: "complete",
    color: "#34c759",
  },
  {
    title: "Deceased Information",
    subtitle: "2 fields missing information",
    progress: "6/8",
    status: "warning",
    color: "#f59e0b",
  },
  {
    title: "Service Information",
    subtitle: "3 fields missing ,complete",
    progress: "4/7",
    status: "warning",
    color: "#f59e0b",
  },
  {
    title: "Venue Information",
    subtitle: "All fields filled",
    progress: "7/7",
    status: "complete",
    color: "#34c759",
  },
];

export const serviceData: ServiceData = {
  name: "Muzukuru Pro",
  price: "$699.00",
  additionalServices: null,
  total: "$699.00",
};

export const streamData: StreamData = {
  id: "148",
  title: "STREAM FOR MOLLIE SPRING",
  date: "Tue,08 February 2026",
  time: "10:00 AM - 11:00 AM",
  locationName: "B.S Leon Trust",
  locationAddress: "Monavale Road, Belvedere, Harare",
};

export const tabs: string[] = [
  "Booking",
  "Proposal",
  "Memory Table",
  "Client Review",
  "Audit",
];

export const streamTabs: string[] = ["Stream 1", "2", "3"];
